<template>
  <div>
    <div class="w-full">
      <div class="animate-pulse">
        <div class="flex-1">
          <div class="h-1.5 bg-blue-500"></div>
        </div>
      </div>
    </div>
    <div>
      <div class="py-2 flex items-center flex-col">
        <div class="loader-dots block relative w-20 h-5 mt-2">
          <div class="absolute  top-0 mt-1 w-3 h-3 rounded-full bg-blue-500"></div>
          <div class="absolute top-0 mt-1 w-3 h-3 rounded-full bg-blue-500"></div>
          <div class="absolute top-0 mt-1 w-3 h-3 rounded-full bg-blue-500"></div>
          <div class="absolute top-0 mt-1 w-3 h-3 rounded-full bg-blue-500"></div>
        </div>
        <div class="text-gray-500 text-xs font-light mt-2 text-center">
          Cargando...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderInside",
}
</script>

<style scoped>

</style>